export default __webpack_public_path__ + "static/media/Personaje_Banner_Promo.a27b2ed4.webp";